<template>
    <div class="ui-form relative">
        <div class="ui-form__white"></div>
        <div class="ui-form__bg"></div>
        <div class="ui-form__content relative d-flex column align-center">
            <p class="text-xl color-27">{{ title ?? "" }}</p>
            <p class="subtitle text-s color-27">{{ subtitle ?? "" }}</p>
            <form class="d-flex column" id="form-2">
                <div class="d-flex align-center input" :class="{'error': isError && data.name.toString().trim().length == 0}">
                    <input type="text" @input="handleInput" placeholder="Name" class="text-s font-400" v-model="data.name" required maxlength="100"/>
                    <svg v-if="isError && data.name.toString().trim().length == 0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10ZM10 5C10.1989 5 10.3897 5.07902 10.5303 5.21967C10.671 5.36032 10.75 5.55109 10.75 5.75V10.25C10.75 10.4489 10.671 10.6397 10.5303 10.7803C10.3897 10.921 10.1989 11 10 11C9.80109 11 9.61032 10.921 9.46967 10.7803C9.32902 10.6397 9.25 10.4489 9.25 10.25V5.75C9.25 5.55109 9.32902 5.36032 9.46967 5.21967C9.61032 5.07902 9.80109 5 10 5ZM10 15C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13C9.73478 13 9.48043 13.1054 9.29289 13.2929C9.10536 13.4804 9 13.7348 9 14C9 14.2652 9.10536 14.5196 9.29289 14.7071C9.48043 14.8946 9.73478 15 10 15Z" fill="#FF3D00"/>
                    </svg>
                </div>
                <div class="d-flex align-center input" :class="{'error': isError && !emailRegex.test(data.email)}">
                    <input type="email" placeholder="Email"  class="text-s font-400" v-model="data.email" pattern="^.+@.+\.[a-zA-Z]{2,63}$" required maxlength="250"/>
                    <svg v-if="isError && !emailRegex.test(data.email)" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10ZM10 5C10.1989 5 10.3897 5.07902 10.5303 5.21967C10.671 5.36032 10.75 5.55109 10.75 5.75V10.25C10.75 10.4489 10.671 10.6397 10.5303 10.7803C10.3897 10.921 10.1989 11 10 11C9.80109 11 9.61032 10.921 9.46967 10.7803C9.32902 10.6397 9.25 10.4489 9.25 10.25V5.75C9.25 5.55109 9.32902 5.36032 9.46967 5.21967C9.61032 5.07902 9.80109 5 10 5ZM10 15C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13C9.73478 13 9.48043 13.1054 9.29289 13.2929C9.10536 13.4804 9 13.7348 9 14C9 14.2652 9.10536 14.5196 9.29289 14.7071C9.48043 14.8946 9.73478 15 10 15Z" fill="#FF3D00"/>
                    </svg>
                </div>
                <div class="input"><textarea class="text-s font-400" placeholder="Message" v-model="data.message"></textarea></div>
            </form>
            <UiButton text="Drop Us a Line" icon="heart" iconPos="right" second big @click="send"></UiButton>
        </div>
    </div>
    <UiModal v-if="isSent" :isCalled="isSent" :isParentSuccess="isSuccess" @close="closeModal"></UiModal>
</template>

<script setup>
import {ref} from "vue";
import UiButton from './UiButton.vue';
import UiModal from './UiModal.vue';
const props = defineProps({
    title: String,
    subtitle: String
})

const isSuccess = ref(false);

const data = ref({
    name: "",
    email:"",
    subject: "",
    message: ""
})

const closeModal = () => {
    isSent.value = false;
    document.body.classList.remove('no-scroll');
}

const isSent = ref(false);
const isError = ref(false);
const emailRegex = ref(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);

const validate = () => {
    let error = false;
    Object.entries(data.value).map(([key, value]) => {
        if(key == 'name' && value.toString().trim().length == 0) {
            error = true;
            data.value.name = "";
        }
        if(key === 'email' && !emailRegex.value.test(value)) error = true;
    });
    return error;
}

const handleInput = (event) => {
    data.value.name = event.target.value;
    if(isError.value) validate();
}

const resetForm = () => {
    data.value = {
        name: "",
        email: "",
        subject: "",
        message: ""
    }
}

const fetchData = (formdata) => {
    const request = {
        method: 'POST',
        body: formdata,
        mode: 'no-cors',
    }

    fetch('https://license.darmius.kz/mailsend', request)
    .then(response => {
        isSent.value = true;
        document.body.classList.add('no-scroll')
        isSuccess.value = true;
        resetForm();
    })
    .catch(e => {
        isSent.value = true;
        document.body.classList.add('no-scroll')
        isSuccess.value = false;
        resetForm();
    })
}

const send = () => {
    let form = document.getElementById('form-2');
    isError.value = validate();
    form.reportValidity();
    if(!isError.value) {
        const formdata = new FormData();
        formdata.append('id', 'fireflyad-technologies');
        formdata.append('name', data.value.name);
        formdata.append('email', data.value.email);
        formdata.append('emailto', "info@fireflyad.tech");
        formdata.append('message', data.value.message);
        formdata.append('subject', data.value.subject);

        fetchData(formdata)
    }
}

</script>

<style lang="scss" scoped>
.ui-form {
    padding: 96px 0;
    overflow: hidden;
    &__white {
        position: absolute;
        top: -70px;
        left: 0;
        height: 133px;
        background: #FFF;
        filter: blur(35px);
        width: 100%;
        z-index: 2;
    }
    &__bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: url('../../assets/images/bg.jpg') no-repeat center/cover;
        z-index: 1;
    }
    &__content {
        // padding: 96px 0;
        margin: auto;
        max-width: 850px;
        text-align: center;
        z-index: 2;
        & .subtitle {
            margin: 48px 0 64px;
            width: 70%;
        }
        & .btn {
            width: 514px;
            margin-top: 40px;
        }
    }
}
.input {
    width: 100%;
    &.error input, &.error textarea {
        border-bottom: 1px solid #FF3D00;
    }
    & input, textarea {
        padding: 24px 16px;
        border: none;
        border-bottom: 1px solid rgba(39, 39, 39, 0.10);
        outline: none;
        width: 100%;
        background: none;
    }

    & textarea {
        resize: none;
        min-height: 144px;
        overflow: hidden;
    }
}

form {
    max-width: 504px;
    gap: 24px;
    width: 100%;
}

@media (max-width: 1220px) {
    .text-xl{
        padding: 0 5%;
    }
}

@media (max-width: 768px) {
    .ui-form {
        &__bg {
            height: 120%;
            background: url('../../assets/images/bg-mob.jpg') no-repeat center/cover;
        }
        &__white {
            width: 200%;
            left: -50%;
        }
        &__content {
            padding: 0 30px;
            & .btn {
                width: 100%;
            }
            & .subtitle {
                margin: 30px 0 40px;
                font-size: 20px;
                line-height: 28px;
                width: 100%;
            }
        }
        form {
            gap: 20px;
            & .text-s{ 
                padding: 20px 15px;
                font-size: 20px;
                line-height: 28px; 
            }
            textarea {
                min-height: 104px !important;
            }
        }
    }
}

@media (max-width: 425px) {
    .ui-form {
        padding: 60px 0 64px;
        &__content {
            align-items: flex-start !important;
            & .subtitle {
                margin: 28px 0 30px;
            }
            & .btn {
                margin-top: 40px;
            }
        }
        .text-xl {
            padding: 0;
            margin: 0 auto;
        }
    } 
}  
</style>